import * as React from 'react';
import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import commons from '../../../assets/styles/commons';
import colors from '../../../assets/styles/colors';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputMask from 'react-input-mask';
interface CustomizedInputsProps {
  label?: string;
  defaultValue?: any;
  value?: any;
  id?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  size?: 'small' | 'medium';
  startAdornment?: any;
  endAdornment?: any;
  mask?: string;
}

const CustomInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
    color: colors.neutral.gray,
  },

  '&.MuiInputBase-root ': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: colors.secondary.softBlue,
    border: '1px solid',
    borderColor: colors.neutral.gray,
    flex: 1,
    width: 'auto',
    height: '18px',
    padding: '5px 12px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    fontFamily: commons.fontFamily,
    fontVariant: 'lining-nums',
  },

  '& .MuiTypography-root': {
    fontFamily: commons.fontFamily,
    color: colors.neutral.gray,
    fontSize: 18,
  },
  '& .MuiInputAdornment-root': {
    marginLeft: 0,
  },

  '& .MuiInputAdornment-positionStart': {
    marginRight: 0,
  },
}));

const InputDisabled: React.FC<CustomizedInputsProps> = ({
  label,
  defaultValue,
  value,
  id,
  mask,
  style,
  onChange,
  size = 'medium',
  startAdornment,
  endAdornment,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <Box
      component="div"
      sx={{
        display: 'grid',
      }}
    >
      <FormControl size={size}>
        <InputLabel
          variant="standard"
          shrink
          htmlFor={id}
          sx={{
            fontFamily: commons.fontFamily,
            color: colors.neutral.gray,
            fontSize: 18,
            '&:focus': {
              color: colors.neutral.gray,
            },
            ...style,
          }}
        >
          {label}
        </InputLabel>
        {mask ? (
          <InputMask
            mask={mask}
            value={value}
            onChange={onChange}
            disabled={true}
          >
            {(inputProps: any) => (
              <CustomInput
                {...inputProps}
                id={id}
                disabled={true}
                endAdornment={
                  <InputAdornment position="end">{endAdornment}</InputAdornment>
                }
                startAdornment={
                  <InputAdornment position="start">
                    {startAdornment}
                  </InputAdornment>
                }
              />
            )}
          </InputMask>
        ) : (
          <CustomInput
            value={value !== undefined && value !== null ? value : defaultValue}
            onChange={handleChange}
            id={id}
            disabled={true}
            size={size}
            endAdornment={
              <InputAdornment position="end">{endAdornment}</InputAdornment>
            }
            startAdornment={
              <InputAdornment position="start">{startAdornment}</InputAdornment>
            }
          />
        )}
      </FormControl>
    </Box>
  );
};

export default InputDisabled;
